"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

/* eslint-disable @typescript-eslint/no-this-alias */
define(['app', './../translationsUtils/modal', 'magnific-popup'], function (app, TranslationModalSanatizer) {
  return app.Marionette.ItemView.extend({
    template: false,
    contentModal: function contentModal(url) {
      var self = this;
      app.$.get(url, function (html) {
        try {
          self.$el.html(html);
        } catch (e) {
          /* YII active form script is failing and silently preventing this function from continuing: try catch to the rescue */
        }

        app.init(self.$el);
      });
      this.showModal(arguments);
    },
    showModal: function showModal(view, options) {
      var _options;

      var modalTranslations = app.translations ? TranslationModalSanatizer(app.translations.get('modal')) : false;

      if (!options) {
        options = view;
        view = false;
      }

      if (!view) view = this.$el;
      _options = {
        items: {
          src: view,
          type: 'inline'
        }
      };
      if (this.options.mainClass) _options.mainClass = this.options.mainClass;
      _options = app._.extend(modalTranslations || {}, _options, options);
      this.opened = app.$(view);
      app.$.magnificPopup.open(_options);
    },
    hideModal: function hideModal() {
      if (!this.opened) return false;
      this.opened = false;
      app.$.magnificPopup.close();
    },
    initialize: function initialize(options) {
      var self = this;
      var eventShow = 'modal:show';
      var eventHide = 'modal:hide';
      var eventContent = 'modal:content';
      var id = options.modal_id ? options.modal_id : this.$el.attr('id') ? this.$el.attr('id') : false; // Update the variable for modals;

      if (!app.modals) app.modals = [];

      if (id) {
        eventShow = 'modal:' + id + ':show';
        eventHide = 'modal:' + id + ':hide';
        eventContent = 'modal:' + id + ':content';

        if (app._.has(app.modals, eventShow) && app._.has(app.modals, eventHide)) {
          app.notify({
            type: 'error',
            msg: "This modal already exist, you can't execute the same modal twice"
          });
          return false;
        } else {
          app.modals.push(eventShow);
          app.modals.push(eventHide);
        }
      } else {
        app.notify({
          type: 'error',
          msg: 'Modals needs data.modal_id to be specify, or otherwise id of the element'
        });
        return false;
      }

      app.events.commands.setHandler(eventShow, function () {
        if (id === 'login' && (0, _globals.default)('application') === 'hub') {
          window.location.href = (0, _absoluteUrlRuntime.resolveUrl)('/member/login');
        } else {
          self.showModal.apply(self, arguments);
        }
      });
      app.events.commands.setHandler(eventHide, function () {
        self.hideModal.apply(self, arguments);
      });
      app.events.commands.setHandler(eventContent, function () {
        self.contentModal.apply(self, arguments);
      });
    }
  });
});